var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNpsedit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3625_22823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3999 6.5H4.7999C4.16338 6.5 3.55293 6.75286 3.10285 7.20294C2.65276 7.65303 2.3999 8.26348 2.3999 8.9V19.7C2.3999 20.3365 2.65276 20.947 3.10285 21.3971C3.55293 21.8471 4.16338 22.1 4.7999 22.1H15.5999C16.2364 22.1 16.8469 21.8471 17.297 21.3971C17.747 20.947 17.9999 20.3365 17.9999 19.7V16.1",
    stroke: "#C4C4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3999 16.1003H11.9999L22.1999 5.90027C22.6773 5.42288 22.9455 4.7754 22.9455 4.10027C22.9455 3.42514 22.6773 2.77766 22.1999 2.30027C21.7225 1.82288 21.075 1.55469 20.3999 1.55469C19.7248 1.55469 19.0773 1.82288 18.5999 2.30027L8.3999 12.5003V16.1003Z",
    stroke: "#C4C4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7998 4.09998L20.3998 7.69998",
    stroke: "#C4C4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3625_22823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpsedit);
export default __webpack_public_path__ + "static/media/npsedit.f47efc85cd75ac92a225eef7c39c5bd4.svg";
export { ForwardRef as ReactComponent };